export default "__VITE_ASSET__LMhKgXvn__"